<div [formGroup]="parentForm || udfForm">
  <!-- Dropdown UDF Field -->
  <mat-form-field appearance="outline" *ngIf="getLowerType() === 'dropdown' || getLowerType() === 'dropdownlist' || getLowerType() === 'dropdownmenu' || getLowerType() === 'dropdown ' || getLowerType() === 'dropDown'.toLowerCase()">
    <mat-label>{{ displayLabel }}{{ required ? ' *' : '' }}</mat-label>
    <mat-select
      [formControlName]="resolvedControlName"
      (selectionChange)="onUDFChange()"
      panelClass="opt-auto-complete"
    >
      <div class="search-container">
        <input
          [formControl]="searchControl"
          [placeholder]="'Search ' + (placeholder || displayLabel)"
          class="opt-auto-complete-input"
        />
      </div>
      <mat-option *ngFor="let option of filteredOptions" [value]="option.id">
        {{ option.name }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="(parentForm || udfForm).get(resolvedControlName)?.hasError('required') && (parentForm || udfForm).get(resolvedControlName)?.touched">
      {{ getErrorMessage() }}
    </mat-error>
  </mat-form-field>

  <!-- Textbox UDF Field -->
  <mat-form-field appearance="outline" *ngIf="getLowerType() === 'textbox' || getLowerType() === 'text'">
    <mat-label>{{ displayLabel }}{{ required ? ' *' : '' }}</mat-label>
    <input
      matInput
      [placeholder]="placeholder"
      [formControlName]="resolvedControlName"
      (input)="onUDFChange()"
      autocomplete="off"
    />
    <mat-error *ngIf="(parentForm || udfForm).get(resolvedControlName)?.hasError('required') && (parentForm || udfForm).get(resolvedControlName)?.touched">
      {{ getErrorMessage() }}
    </mat-error>
  </mat-form-field>

  <!-- Date UDF Field -->
  <mat-form-field appearance="outline" *ngIf="getLowerType() === 'date' || getLowerType() === 'datepicker'">
    <mat-label>{{ displayLabel }}{{ required ? ' *' : '' }}</mat-label>
    <input
      matInput
      [matDatepicker]="picker"
      [placeholder]="placeholder"
      [formControlName]="resolvedControlName"
      (dateChange)="onUDFChange()"
      autocomplete="off"
    />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    <mat-error *ngIf="(parentForm || udfForm).get(resolvedControlName)?.hasError('required') && (parentForm || udfForm).get(resolvedControlName)?.touched">
      {{ getErrorMessage() }}
    </mat-error>
  </mat-form-field>

  <!-- Fallback: render textbox for any unknown type -->
  <mat-form-field appearance="outline" *ngIf="!(getLowerType() === 'dropdown' || getLowerType() === 'dropdownlist' || getLowerType() === 'dropdownmenu' || getLowerType() === 'dropdown ' || getLowerType() === 'dropDown'.toLowerCase() || getLowerType() === 'textbox' || getLowerType() === 'text' || getLowerType() === 'date' || getLowerType() === 'datepicker')">
    <mat-label>{{ displayLabel }}{{ required ? ' *' : '' }}</mat-label>
    <input
      matInput
      [placeholder]="placeholder"
      [formControlName]="resolvedControlName"
      (input)="onUDFChange()"
      autocomplete="off"
    />
    <mat-error *ngIf="(parentForm || udfForm).get(resolvedControlName)?.hasError('required') && (parentForm || udfForm).get(resolvedControlName)?.touched">
      {{ getErrorMessage() }}
    </mat-error>
  </mat-form-field>
</div>

